import type { CapiProductPage } from 'types/capi/pdp';

import usePageData from '~/hooks/usePageData';
import useRegion from '~/hooks/useRegion';
import gtm from '~/services/gtm.client';

import ProductCardCarousel from './ProductCardCarousel';

const FIRST_MODULE_POSITION = 1;

const WhatsHot = ({ modulePosition }: { modulePosition: number }) => {
  const product = usePageData<CapiProductPage>();

  const sendGtmEvent = () => {
    gtm.sendUserInteractionEvent("What's Hot View More Drops", 'Body');
  };

  return (
    <ProductCardCarousel
      title="What's hot"
      moduleType="pdp-whats-hot-carousel"
      modulePosition={modulePosition}
      viewMoreCopy="View more drops"
      onViewMoreProductsClick={sendGtmEvent}
      viewMoreUrl={product.view_more_products_path}
      id="featured-products"
      products={product.featured_products}
      padImages={product.pad_images}
      allowNotifications={product.allow_user_notifications}
    />
  );
};

const RelatedProducts = ({ modulePosition }: { modulePosition: number }) => {
  const product = usePageData<CapiProductPage>();

  return (
    <ProductCardCarousel
      title="Similar products"
      moduleType="pdp-similar-products-carousel"
      modulePosition={modulePosition}
      id="similar-products"
      products={product.related_products}
      padImages={product.pad_images}
      allowNotifications={product.allow_user_notifications}
    />
  );
};

const ProductCardCarousels = () => {
  const products = usePageData<CapiProductPage>();
  const region = useRegion();

  const showRelatedProductCarousel = products.related_products.length !== 0;

  if (region.code !== 'GB') return null;

  return (
    <div className="flex flex-col gap-8 bg-concrete py-8 desktop:gap-10 desktop:py-10">
      {showRelatedProductCarousel && (
        <div className="content-width">
          <RelatedProducts modulePosition={FIRST_MODULE_POSITION} />
        </div>
      )}

      <div className="content-width">
        <WhatsHot
          modulePosition={
            showRelatedProductCarousel
              ? FIRST_MODULE_POSITION + 1
              : FIRST_MODULE_POSITION
          }
        />
      </div>
    </div>
  );
};

export default ProductCardCarousels;
